/** AUTO GENERATED FROM "node ./src/utils/convert-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';


class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg id="b4e41ac2-777b-4b3c-a3c3-01133c45ebfc" width="24" height="24" viewBox="0 0 24 24" fill="currentColor" className={classNames('nmx-icon', className)} ref={svgRef} {...otherProps}>
  <defs>
    <mask id="f2783482-0cbd-47dc-8a85-5551fab0a60a" x="0" y="0" width="24" height="24" maskUnits="userSpaceOnUse">
      <g id="bda5254e-2071-4e62-bb0a-0475782a7ef6">
        <path id="b3f6ab57-fc9f-4213-bc73-04707b5482dc" d="M3.11,17.43l0,.13a3.51,3.51,0,0,0,1,3.24,3.35,3.35,0,0,0,2.4,1,3.94,3.94,0,0,0,.77-.08l.15,0,.11-.11L14.15,15l1.91,1.79.69-.73-1.89-1.77c4.13-4.11,5.87-5.86,6.47-6.55l.2-.14a1.23,1.23,0,0,0,.17-1.32A5,5,0,0,0,20.41,4.4,3.71,3.71,0,0,0,18,3h0a1,1,0,0,0-.72.27.85.85,0,0,0-.14.19c-.71.6-2.42,2.32-6.91,6.82l-7,7ZM19.7,5.1a3.24,3.24,0,0,1,1.1,1.64,1.28,1.28,0,0,1-.66-.18L20,6.46l-.14-.1,0,0a6.26,6.26,0,0,1-.49-.41l-.1-.09-.26-.27c-.76-.84-1-1.37-1-1.56C18.13,4,18.69,4.09,19.7,5.1Zm-2.53-.36a2.29,2.29,0,0,0,.1.23,5.47,5.47,0,0,0,.85,1.17l.07.09,0,0,0,0,0,0,.08.08a.09.09,0,0,0,.05,0l0,0a5.22,5.22,0,0,0,1.18.92l.05,0,.11.06.26.13-6,6a3.7,3.7,0,0,1-2.89-2.9c3-3,5-5,6-6ZM4,17.93l6.31-6.35a4.76,4.76,0,0,0,2.91,2.87L6.89,20.79a2.36,2.36,0,0,1-2.11-.69A2.52,2.52,0,0,1,4,17.93Z" fill="#fff" style={{fillRule: "evenodd"}}/>
      </g>
    </mask>
  </defs>
  <g id="a88f8e28-cd76-4469-8306-a53dcaf7dce3">
    <g id="a7dc4100-7a36-44ce-8bdd-5027e5833175">
      <g id="eea390f5-648c-41a4-9127-63a3cd6ec736">
        <path id="e39dcd86-7485-47f0-bb89-216a51d2c339" d="M3.11,17.43l0,.13a3.51,3.51,0,0,0,1,3.24,3.35,3.35,0,0,0,2.4,1,3.94,3.94,0,0,0,.77-.08l.15,0,.11-.11L14.15,15l1.91,1.79.69-.73-1.89-1.77c4.13-4.11,5.87-5.86,6.47-6.55l.2-.14a1.23,1.23,0,0,0,.17-1.32A5,5,0,0,0,20.41,4.4,3.71,3.71,0,0,0,18,3h0a1,1,0,0,0-.72.27.85.85,0,0,0-.14.19c-.71.6-2.42,2.32-6.91,6.82l-7,7ZM19.7,5.1a3.24,3.24,0,0,1,1.1,1.64,1.28,1.28,0,0,1-.66-.18L20,6.46l-.14-.1,0,0a6.26,6.26,0,0,1-.49-.41l-.1-.09-.26-.27c-.76-.84-1-1.37-1-1.56C18.13,4,18.69,4.09,19.7,5.1Zm-2.53-.36a2.29,2.29,0,0,0,.1.23,5.47,5.47,0,0,0,.85,1.17l.07.09,0,0,0,0,0,0,.08.08a.09.09,0,0,0,.05,0l0,0a5.22,5.22,0,0,0,1.18.92l.05,0,.11.06.26.13-6,6a3.7,3.7,0,0,1-2.89-2.9c3-3,5-5,6-6ZM4,17.93l6.31-6.35a4.76,4.76,0,0,0,2.91,2.87L6.89,20.79a2.36,2.36,0,0,1-2.11-.69A2.52,2.52,0,0,1,4,17.93Z" className="icon-fill"/>
      </g>
      <g style={{mask: "url(#f2783482-0cbd-47dc-8a85-5551fab0a60a)"}}>
        <g id="b99b5057-cc2f-4454-8c9c-da7826735f9f">
          <rect id="a9618d55-e300-4f40-929c-31f93dbcb73b" width="24" height="24" className="icon-fill"/>
        </g>
      </g>
      <g style={{mask: "url(#f2783482-0cbd-47dc-8a85-5551fab0a60a)"}}>
        <rect id="fb6c4c2d-11ae-4ce2-b80b-aec8aa1f6dd0" width="24" height="24" className="icon-fill"/>
      </g>
    </g>
  </g>
</svg>

    );
  }
}

Icon.displayName = 'RolledScrollIcon';

export default Icon;
